import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  House, 
  Cube, 
  EnvelopeSimple, 
  Gear, 
  FileText, 
  SignOut,
  ArrowLeft,
  Images
} from '@phosphor-icons/react';
import { useAuth } from '../App';

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const navItems = [
    { path: '/admin', icon: House, label: 'Dashboard' },
    { path: '/admin/concepts', icon: Cube, label: 'Bar Mobile' },
    { path: '/admin/portfolio', icon: Images, label: 'Studio Créa' },
    { path: '/admin/contacts', icon: EnvelopeSimple, label: 'Demandes' },
    { path: '/admin/pages', icon: FileText, label: 'Pages' },
    { path: '/admin/settings', icon: Gear, label: 'Paramètres' },
  ];

  return (
    <div className="min-h-screen bg-[#050505] flex">
      {/* Sidebar */}
      <aside 
        data-testid="admin-sidebar"
        className="fixed left-0 top-0 bottom-0 w-64 bg-[#0A0A0A] border-r border-white/5 flex flex-col"
      >
        {/* Logo */}
        <div className="p-6 border-b border-white/5">
          <Link to="/admin" className="font-display text-xl text-white">
            STUDIOBAR
          </Link>
          <p className="text-xs text-stone-500 mt-1">Administration</p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-6">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`admin-nav-${item.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-6 py-3 transition-colors ${
                  isActive 
                    ? 'text-[#C5A059] bg-[#C5A059]/10 border-r-2 border-[#C5A059]' 
                    : 'text-stone-400 hover:text-white hover:bg-white/5'
                }`}
              >
                <Icon size={20} weight={isActive ? 'fill' : 'light'} />
                <span className="text-sm">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        {/* User & Actions */}
        <div className="p-6 border-t border-white/5">
          <Link
            to="/"
            data-testid="admin-back-to-site"
            className="flex items-center gap-2 text-stone-400 hover:text-white transition-colors mb-4"
          >
            <ArrowLeft size={16} weight="light" />
            <span className="text-sm">Retour au site</span>
          </Link>
          
          <div className="flex items-center gap-3 mb-4">
            {user?.picture && (
              <img 
                src={user.picture} 
                alt={user.name}
                className="w-8 h-8 rounded-full"
              />
            )}
            <div className="flex-1 min-w-0">
              <p className="text-sm text-white truncate">{user?.name}</p>
              <p className="text-xs text-stone-500 truncate">{user?.email}</p>
            </div>
          </div>
          
          <button
            onClick={handleLogout}
            data-testid="admin-logout"
            className="flex items-center gap-2 text-stone-400 hover:text-red-400 transition-colors w-full"
          >
            <SignOut size={16} weight="light" />
            <span className="text-sm">Déconnexion</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 ml-64">
        <div className="p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
